import { render, staticRenderFns } from "./PaginateButton.vue?vue&type=template&id=bcd857ec&scoped=true&"
import script from "./PaginateButton.vue?vue&type=script&lang=js&"
export * from "./PaginateButton.vue?vue&type=script&lang=js&"
import style0 from "./PaginateButton.vue?vue&type=style&index=0&id=bcd857ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd857ec",
  null
  
)

export default component.exports